goog.provide('el8.appchart.dialog.prenatalFlowsheet');

goog.require('el8.ptdata.prenatalFlowsheets');
goog.require('el8.ptdata.prenatalFlowsheetVisitMeasurements');
goog.require('el8.uiwidget.ClickText');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.appchart.dialog.prenatalFlowsheet');
goog.require('el8.service.infoField');
goog.require('el8.util.consts');
goog.require('el8.appshared.form.buttons');
goog.require('el8.service.tooltip');

el8.appchart.dialog.prenatalFlowsheet = (function() {
    var currPtPrenatalFlowsheet = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Prenatal Flowsheet',
        autoHeight: true,
        width: 1050,
        contentFn: function() {
            return el8.template.appchart.dialog.prenatalFlowsheet.form();
        },
        showXButton: true
    });

    var form = new el8.uiwidget.Form({
        fields: [
            //
            // FS fields
            //
            {
                name: 'name',
                selector: ':input[name="title"]',
                maxLength: 255,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'edd',
                selector: ':input[name="edd"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                datePickerOpts: {}
            },
            {
                name: 'eddFinal',
                selector: ':input[name="eddFinal"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'eddNotes',
                selector: ':input[name="eddNotes"]',
                infoText: 'EDD notes (e.g. by LMP, US...)',
                maxLength: 255,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'lmpDate',
                selector: ':input[name="lmpDate"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                datePickerOpts: {}
            },
            {
                name: 'weightPrepreg',
                selector: ':input[name="weightPrepreg"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 6
            },
            {
                name: 'bpSPrepreg',
                selector: ':input[name="bpSPrepreg"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 3
            },
            {
                name: 'bpDPrepreg',
                selector: ':input[name="bpDPrepreg"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 3
            },
            {
                name: 'synopsis',
                selector: ':input[name="synopsis"]',
                height: 2*el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true
            },

            //
            // Per-measurement fields
            //
            {
                name: 'date',
                selector: ':input[name="date"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                defaultVal: function() { return el8.service.tz.today().asString(); },
                datePickerOpts: { maxDate: el8.service.tz.today() }
            },
            {
                name: 'weeksGest',
                selector: ':input[name="weeksGest"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '# wks',
                maxLength: 4
            },
            {
                name: 'weight',
                selector: ':input[name="weight"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'lbs',
                maxLength: 5
            },
            {
                name: 'bpS',
                selector: ':input[name="bpS"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'sys',
                maxLength: 3
            },
            {
                name: 'bpD',
                selector: ':input[name="bpD"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'dia',
                maxLength: 3
            },

            {
                name: 'fundlHt',
                selector: ':input[name="fundlHt"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'cm',
                maxLength: 3
            },
            {
                name: 'pres',
                selector: ':input[name="pres"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 10
            },
            {
                name: 'fhr',
                selector: ':input[name="fhr"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'bpm'
            },
            {
                name: 'fetalMvmt',
                selector: ':input[name="fetalMvmt"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 5
            },
            {
                name: 'pretermSymp',
                selector: ':input[name="pretermSymp"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 5
            },
            {
                name: 'crvxExamDil',
                selector: ':input[name="crvxExamDIL"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'dil',
                maxLength: 5
            },
            {
                name: 'crvxExamDff',
                selector: ':input[name="crvxExamDFF"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'eff',
                maxLength: 5
            },
            {
                name: 'crvxExamSta',
                selector: ':input[name="crvxExamSTA"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'sta',
                maxLength: 5
            },
            {
                name: 'urineAlb',
                selector: ':input[name="urineAlb"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'alb',
                maxLength: 20
            },
            {
                name: 'urineGlu',
                selector: ':input[name="urineGlu"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'glu',
                maxLength: 3
            },
            {
                name: 'edema',
                selector: ':input[name="edema"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 5
            },
            {
                name: 'nextAppt',
                selector: ':input[name="nextAppt"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'wks',
                maxLength: 5
            },
            {
                name: 'comments',
                selector: ':input[name="comments"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 200,
                doShrink: true
            }
        ]
    });

    var _fillPreviousMeasurements = function() {
        var $contentElt = that.getDialogContentElt();
        $('.el8PrenatalFlowsheetPreviousMeasurements', $contentElt).empty();

        var measurements = _.sortBy(currPtPrenatalFlowsheet.getVisitMeasurements(),
                                    function(item) { return item.getDate().getTime(); });

        if (measurements.length && !_.last(measurements).isSignedOff()) {
            // If the latest measurement is unsigned/draft, pop it off and populate the form
            var draftMeasurement = measurements.pop();
            form.populate(draftMeasurement.asSoyMap());
        }

        // Process each measurement bundle
        _(measurements).each(function (visitMeasurements) {
            var weightTrend = null;
            var firstInitial = null;
            var middleInitial = null;
            var lastInitial = null;
            var initials = null;
            var fullName = null;

            // Calculate the delta from the pre-preg wt for this measurement
            if (visitMeasurements.getWeight() &&
                parseInt(visitMeasurements.getWeight(), 10) > 0 &&
                currPtPrenatalFlowsheet.getWeightPrepreg() &&
                parseInt(currPtPrenatalFlowsheet.getWeightPrepreg(), 10) > 0) {

                weightTrend = parseInt(visitMeasurements.getWeight(), 10) - parseInt(currPtPrenatalFlowsheet.getWeightPrepreg(), 10);

                if (weightTrend > 0) {
                    weightTrend = "+" + weightTrend.toString();
                } else {
                    weightTrend = weightTrend.toString();
                }
            }

            var signer = el8.data.practiceUsers.getById(visitMeasurements.getSignUserId());
            if (!signer) {
                // This is sanity check. It should not be the case where there is
                // more than one draft and that draft, if exists, was not pop'd off above
                return;
            } else {
                var firstInitial = signer.getFirstName().substring(0,1);
                var middleInitial = signer.getMiddleName().substring(0,1);
                var lastInitial = signer.getLastName().substring(0,1);
                initials = firstInitial + (firstInitial ? '.' : '') + middleInitial + (middleInitial ? '.' : '') + lastInitial + (lastInitial ? '.' : '');
                fullName = signer.getFullName();
            }

            // Use raw PrenatalFlowsheetVisitMeasurement `date` string to avoid TimezoneJS.Date
            // entity conversion which can render off-by-one in `.visitMeasurements` soy template
            var rawMeasurementDate = visitMeasurements.rawData.date;
            
            $('.el8PrenatalFlowsheetPreviousMeasurements', $contentElt).append(
                el8.template.appchart.dialog.prenatalFlowsheet.visitMeasurements({
                    'id': visitMeasurements.getId(),
                    'date': rawMeasurementDate,
                    'weeksGest': visitMeasurements.getWeeksGest(),
                    'fundlHt': visitMeasurements.getFundlHt(),
                    'pres': visitMeasurements.getPres(),
                    'fhr': visitMeasurements.getFhr(),
                    'fetalMvmt': visitMeasurements.getFetalMvmt(),
                    'pretermSymp': visitMeasurements.getPretermSymp(),
                    'crvxExamDil': visitMeasurements.getCrvxExamDil(),
                    'crvxExamDff': visitMeasurements.getCrvxExamDff(),
                    'crvxExamSta': visitMeasurements.getCrvxExamSta(),
                    'bpS': visitMeasurements.getBpS(),
                    'bpD': visitMeasurements.getBpD(),
                    'weight': visitMeasurements.getWeight(),
                    'urineAlb': visitMeasurements.getUrineAlb(),
                    'urineGlu': visitMeasurements.getUrineGlu(),
                    'edema': visitMeasurements.getEdema(),
                    'nextAppt': visitMeasurements.getNextAppt(),
                    'comments': visitMeasurements.getComments(),
                    'weightTrend': weightTrend,
                    'initials': initials
                })
            );

            // Attach a tooltip to the newly created elt
            var $elt = $('.initials[data-id="'+visitMeasurements.getId()+'"]', $contentElt);
            el8.service.tooltip.create({
                anchor: $elt,
                text: 'Signed by ' + fullName,
                theme: ['larger', 'dark']
            });
        });
    };

    var _validateForm = function(form) {
        // Default name to "Prenatal Flowsheet"
        if (!form.getVal('name') || form.getVal('name') === '') {
            form.setVal('name', 'Prenatal Flowsheet');
        }

        // For Entire Flowsheet: EDD (only)
        if (!form.getVal('edd') || form.getVal('edd') === '') {
            el8.uiwidget.alert('Please enter an estimated delivery date.',
                               form.getInfoField('edd').getInputField());
            return false;
        }

        //
        // Per OB Visit: Date and GA
        //
        if (!form.getVal('date') || form.getVal('date') === '') {
            el8.uiwidget.alert('Please enter a measurement date.',
                               form.getInfoField('date').getInputField());
            return false;
        }
        if (!form.getVal('weeksGest') || form.getVal('weeksGest') === '') {
            el8.uiwidget.alert('Please enter a gestational age in weeks.',
                               form.getInfoField('weeksGest').getInputField());
            return false;
        }

        // Check numerics
        var test = form.getVal('weight');
        if (test && (isNaN(parseFloat(test)) || !isFinite(test))) {
            el8.uiwidget.alert('Please enter a valid numeric weight.',
                               form.getInfoField('weight').getInputField());
            return false;
        }

        test = form.getVal('bpS');
        if (test && (isNaN(parseFloat(test)) || !isFinite(test))) {
            el8.uiwidget.alert('Please enter a valid numeric blood pressure.',
                               form.getInfoField('bpS').getInputField());
            return false;
        }

        test = form.getVal('bpD');
        if (test && (isNaN(parseFloat(test)) || !isFinite(test))) {
            el8.uiwidget.alert('Please enter a valid numeric blood pressure.',
                               form.getInfoField('bpD').getInputField());
            return false;
        }

        test = form.getVal('fundlHt');
        if (test && (isNaN(parseFloat(test)) || !isFinite(test))) {
            el8.uiwidget.alert('Please enter a valid numeric fundal height.',
                               form.getInfoField('fundlHt').getInputField());
            return false;
        }

        return true;
    };

    var _doSignMeasurement = function(form, closeDlg, draft) {
        var valid = _validateForm(form);
        if (!valid) { return false; }

        //
        // The flowsheet
        //
        if (!currPtPrenatalFlowsheet) {
            currPtPrenatalFlowsheet = el8.ptdata.prenatalFlowsheets.create(form.getMapped(),
                                                                           true);
        } else {
            currPtPrenatalFlowsheet.populate(form.getMapped());
        }
        el8.ptdata.prenatalFlowsheets.saveItem(currPtPrenatalFlowsheet, false, {async: false});

        //
        // The measurement
        //
        var vm = null;
        var overwrite = false;

        // If last existing vm is draft, overwrite it with current data, otherwise create new vm
        var existingMeasurements = _.sortBy(currPtPrenatalFlowsheet.getVisitMeasurements(),
                                            function(item) { return item.getDate().getTime(); });

        if (existingMeasurements.length && !_.last(existingMeasurements).isSignedOff()) {
            vm = _.last(existingMeasurements);
            vm.populate(form.getMapped());
            overwrite = true;
        } else {
            vm = el8.ptdata.prenatalFlowsheetVisitMeasurements.create(form.getMapped(), true);
        }

        // Indicates to BE this is a draft measurement
        vm.setDraft(draft ? true : false);
        vm.setFlowsheetId(currPtPrenatalFlowsheet.getId());
        var currFlowsheet = currPtPrenatalFlowsheet;

        el8.ptdata.prenatalFlowsheetVisitMeasurements.saveItem(vm, false, {
            successCb: function(vm) {
                if (overwrite) {
                    // Remove the last vm, push the new vm
                    var vms = _.sortBy(currFlowsheet.getVisitMeasurements(),
                                       function(item) { return item.getDate().getTime(); });
                    vms = _.initial(vms);
                    vms.push(vm);
                    currFlowsheet.setVisitMeasurements(vms);
                } else {
                    currFlowsheet.getVisitMeasurements().push(vm);
                }

                that.hide();
                if (!closeDlg) { that.show({'ptPrenatalFlowsheet': currFlowsheet}); }

                el8.appchart.mainFeeds.chart.update();
                el8.appchart.mainFeeds.reqAct.update();
            }
        });

        return currPtPrenatalFlowsheet;
    };

    var _endFlowsheet = function() {
        if (!currPtPrenatalFlowsheet) {
            el8.uiwidget.alert('Please add measurements before ending this flowsheet.');
            return false;
        }

        currPtPrenatalFlowsheet.setEndDate(el8.service.tz.now());
        el8.ptdata.prenatalFlowsheets.saveItem(currPtPrenatalFlowsheet, false, {
            async: false,
            successCb: function(item) {
                that.hide();
                that.show({'ptPrenatalFlowsheet': item});
            }
        });
    };

    var _reopenFlowsheet = function() {
        currPtPrenatalFlowsheet.setEndDate(null);
        el8.ptdata.prenatalFlowsheets.saveItem(currPtPrenatalFlowsheet, false, {
            async: false,
            successCb: function(item) {
                that.hide();
                that.show({'ptPrenatalFlowsheet': item});
            }
        });
    };

    var _print = function() {
        if (currPtPrenatalFlowsheet) {
            currPtPrenatalFlowsheet.print();
        } else {
            el8.uiwidget.alert('Please add measurements before printing this flowsheet.');
            return false;
        }
    };

    //
    // Buttons
    //
    form.addButton('sign_and_add_another', 'Sign & Add Another', function() {
        var fs = _doSignMeasurement(form, false, false);
        if (fs) {
            that.hide();
            that.show({'ptPrenatalFlowsheet': fs});
        }
    }, true);

    form.addButton('sign_and_close', 'Sign & Close', function() {
        var fs = _doSignMeasurement(form, true, false);
        if (fs) {
            that.hide();
        }
    }, false);

    form.addButton('save_draft_and_close', 'Save as Draft & Close', function() {
        var rv = _doSignMeasurement(form, true, true);
        // If validation failed, don't close
        if (rv) {
            that.hide();
        }
    }, false);
    form.addButton('discard', 'Close', function() { that.hide(); }, false);
    form.addButton('reopen_flowsheet', 'Reopen Flowsheet', function() { _reopenFlowsheet(); }, false);

    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        var $contentElt = that.getDialogContentElt();

        //
        // Set up actions menu
        //
        that._actionsMenu = new el8.uiwidget.NewActionsMenu({
            container: $contentElt,
            anchorTop: $contentElt,
            menuId: 'prenatal-flowsheet-actions-menu'
        });

        $contentElt.on('click', '.actions-trigger',  function(e) {
            var text = 'End Flowsheet';
            var fn = _endFlowsheet;

            if (currPtPrenatalFlowsheet && currPtPrenatalFlowsheet.getEndDate()) {
                text = 'Reopen Flowsheet';
                fn = _reopenFlowsheet;
            }

            var menu = [
                {
                    actionText: 'Print Flowsheet',
                    actionFn: function() { _print(); }
                },
                {
                    actionText: text,
                    actionFn: function() { fn(); }
                }
            ];

            that._actionsMenu.display(
                $(this),
                null,
                {'top': 17, 'left': 20},
                menu
            );

            return false;
        });
    };

    that._calcGA = function () {
        // We want to calc GA when:
        // 1. EDD changes (or is added)
        // 2. Measurement date changes
        var $edd = $(':input[name="edd"]');
        var $date = $(':input[name="date"]');
        if (!$edd.val() || !$date.val()) { return; }

        var eddObj = null;
        var dateObj = null; // measurement date
        var GDateObj = null; // Date of gestation
        var DAYMILLIS = 86400000;

        eddObj = el8.service.tz.newTzDate($edd.val());
        dateObj = el8.service.tz.newTzDate($date.val());

        GDateObj = eddObj.addDays(-280); // Also changed in-place, FYI
        var GAMillis = dateObj - GDateObj;
        var GATotalDays = GAMillis / DAYMILLIS;
        var GAWeeks = GATotalDays / 7;
        var GARemainder =  GAWeeks - Math.floor(GAWeeks);
        var GARemainderDays = Math.round(7 * GARemainder);
        form.setVal('weeksGest',
                    Math.floor(GAWeeks).toString() + '-' + GARemainderDays.toString());
    };


    that._bindTriggers = function() {
        var $contentElt = that.getDialogContentElt();

        // This adjusts the height of the dlg as the notes textarea for a measurement row expands or shrinks
        $contentElt.on('keyup', ':input[name="comments"]',  function(e) {
            var growShrinkFn = function () {
                var GRAY_AREA_ORIG_HEIGHT = 50;
                var $target = $(e.target);
                var newHeight = $target.height();
                var grayArea = $('.el8PrenatalFlowsheetActiveMeasurement', $contentElt);

                if (newHeight > 16) {
                    var delta = newHeight - 14;
                    grayArea.height(GRAY_AREA_ORIG_HEIGHT + delta);
                } else {
                    grayArea.height(GRAY_AREA_ORIG_HEIGHT);
                }
            };

            growShrinkFn();
            _.defer(_.bind(that.adjustHeight, that));
        });


        // Triggers on EDD and DATE to calc GA
        $contentElt.on('change focusout', ':input[name="edd"]',  function(e) {
            that._calcGA();
            return false;
        });

        $contentElt.on('change focusout', ':input[name="date"]',  function(e) {
            var $date = $(e.target);
            var val = $date.val();
            if (val) {
                var dateVal = el8.util.datecompare.processDateInput(val, null, el8.uiwidget.alert);
                if (el8.util.datecompare.isAfterToday(dateVal)) {
                    el8.uiwidget.alert('Please enter a date of today or earlier',
                                       form.getInfoField('date').getInputField());
                    $date.val('');
                    var $ga = $(':input[name="weeksGest"]');
                    $ga.val('');
                } else {
                    that._calcGA();
                }
            }
            return false;
        });

        // Measurement delete trigger
        $contentElt.on('click', '.delete-trigger',  function(e) {
            var itemId = $(e.target).data('id');
            var visitMeasurements = itemId ? el8.ptdata.prenatalFlowsheetVisitMeasurements.getById(itemId) : null;

            el8.uiwidget.deleteConfirm(
                'Prenatal Visit details',
                function() {
                    visitMeasurements.deleteVisitMeasurements();
                    that.hide();
                    that.show({'ptPrenatalFlowsheet': visitMeasurements.getFlowsheet()});
                }
            );

            return false;
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        spec = spec || {};
        currPtPrenatalFlowsheet = spec.ptPrenatalFlowsheet || null;

        if (currPtPrenatalFlowsheet) {
            form.populate(currPtPrenatalFlowsheet.asSoyMap());
            _fillPreviousMeasurements();
        } else {
            form.setVal('name', 'Prenatal Flowsheet');
        }

        // Button adjustments
        if (!currPtPrenatalFlowsheet || !currPtPrenatalFlowsheet.getEndDate() || currPtPrenatalFlowsheet.getEndDate() === '') {
            // "open" state
            form.showButton('discard');
            form.showButton('save_draft_and_close');

            form.hideButton('reopen_flowsheet');

            // Only physicians can sign
            if (el8.data.currUser.isPhysician()) { form.showButton('sign'); }
            else { form.hideButton('sign'); }
        } else {
            // "closed" state
            form.showButton('reopen_flowsheet');

            form.hideButton('discard');
            form.hideButton('sign');
            form.hideButton('save_draft_and_close');
        }

        that._bindTriggers();
        that._calcGA(); // Do this on show too

        var $contentElt = that.getDialogContentElt();
        $('.el8DialogButtonContainer', $contentElt).css('text-align', 'right');

        var extraHeight = 220; // Used to adjust padding for open/closed states

        // If ended, put end date in the title and hide input
        if (currPtPrenatalFlowsheet && currPtPrenatalFlowsheet.getEndDate()) {
            $('.el8PrenatalFlowsheetActiveMeasurement', $contentElt).hide();
            extraHeight -= 53;
        } else {
            $('.el8PrenatalFlowsheetActiveMeasurement', $contentElt).show();
            $('#prenatal-flowsheet-end-date', $contentElt).html('');
        }

        $('.el8PrenatalFlowsheetPreviousMeasurements', $contentElt).height('auto');
        that.adjustHeight();
        $('.el8PrenatalFlowsheetPreviousMeasurements', $contentElt).height($contentElt.height() - extraHeight);
        form.initFocus();

        // Pre-filling WT and BP from latest VN
        var sortedVNs = el8.ptdata.visitNotes.sorted();
        if (sortedVNs.length) {
            var latestVN = el8.ptdata.visitNotes.sorted()[0];
            var vitalsSets = latestVN.getVitalsSets();
            if (!currPtPrenatalFlowsheet ||
                (currPtPrenatalFlowsheet && !currPtPrenatalFlowsheet.getWeightPrepreg())) {
                that._initPreviousWt(vitalsSets, $contentElt);
            }
            if (!currPtPrenatalFlowsheet ||
                (currPtPrenatalFlowsheet && (!currPtPrenatalFlowsheet.getBpSPrepreg() ||
                                             !currPtPrenatalFlowsheet.getBpDPrepreg()))) {
                that._initPreviousBP(vitalsSets, $contentElt);
            }
        }
        that.adjustHeight();
    };

    that._initPreviousWt = function (vitalsSets, $contentElt) {
        var vs = vitalsSets.weight.all();
        if (vs.length) {
            var wtObj = vitalsSets.weight.sorted()[0];
            var wt = wtObj.getWeight();
            var $elt = $('.weightPrepreg', that.getDialogContentElt());
            if (wt) {
                form.setVal('weightPrepreg', wt);
                el8.service.tooltip.create({
                    anchor: $elt,
                    text: 'Recorded: ' + wtObj.getRecordDate().asDateTimeString(),
                    theme: ['larger', 'dark']
                });
            }
        }
    };

    that._initPreviousBP = function (vitalsSets, $contentElt) {
        var vs = vitalsSets.bp.all();
        if (vs.length) {
            var bpObj = vitalsSets.bp.sorted()[0];
            var sys = bpObj.getBpS();
            var dia = bpObj.getBpD();

            if (!sys || sys === '' || !dia || dia === '') {
                return;
            }

            var $sys = $('.bpSPrepreg', that.getDialogContentElt());
            var $dia = $('.bpDPrepreg', that.getDialogContentElt());

            form.setVal('bpSPrepreg', sys);
            form.setVal('bpDPrepreg', dia);

            el8.service.tooltip.create({
                anchor: $sys,
                text: 'Recorded: ' + bpObj.getRecordDate().asDateTimeString(),
                theme: ['larger', 'dark']
            });

            el8.service.tooltip.create({
                anchor: $dia,
                text: 'Recorded: ' + bpObj.getRecordDate().asDateTimeString(),
                theme: ['larger', 'dark']
            });
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        var $contentElt = that.getDialogContentElt();
        $('.el8PrenatalFlowsheetPreviousMeasurements', $contentElt).empty();
        currPtPrenatalFlowsheet = null;
        super_hide.call(that);

        el8.service.tooltip.destroy($('.initials', $contentElt));
        el8.service.tooltip.destroy($('.weightPrepreg', $contentElt));
        el8.service.tooltip.destroy($('.bpSPrepreg', $contentElt));
        el8.service.tooltip.destroy($('.bpDPrepreg', $contentElt));
    };

    return that;
})();
